import { FC, SVGProps } from 'react';

// Five-pip die used by the "Surprise me" control. Stroke + pips both use
// `currentColor` so it themes like the surrounding icon buttons.
export const DiceIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} aria-hidden="true" focusable="false" {...props}>
		<rect x="3" y="3" width="18" height="18" rx="4.5" />
		<circle cx="8" cy="8" r="1.35" fill="currentColor" stroke="none" />
		<circle cx="16" cy="8" r="1.35" fill="currentColor" stroke="none" />
		<circle cx="12" cy="12" r="1.35" fill="currentColor" stroke="none" />
		<circle cx="8" cy="16" r="1.35" fill="currentColor" stroke="none" />
		<circle cx="16" cy="16" r="1.35" fill="currentColor" stroke="none" />
	</svg>
);
